module.exports = __webpack_public_path__ + "97d1d25c36957337ca392a257ce98aa3.jpeg";